



export const threeGeomInstanceVertShader = `
precision highp float;

uniform sampler2D u_plates;

struct PlateData {
    float tlx;
    float tly;
    float trx;
    float bly;
    vec3 tl_up;
    vec3 tr_up;
    vec3 bl_up;
    vec3 br_up;
};


uniform float u_plate_up_scale;
uniform float u_plate_height;
uniform float u_plate_width;

uniform mat4 u_matrix_globe_merc;

uniform float u_zoom_transition;
uniform vec2 u_centerInMerc;
uniform float u_pixelsPerMeterRatio;

uniform float u_scale_factor;

uniform bool u_crossed_dateline;
uniform bool u_near_dateline;

varying vec3 vColor;

#define INDEX 0

attribute float plateIndex;


PlateData getPosPlate(vec3 pos) {
    PlateData plate;

    float plateY = floor(plateIndex / 16.0);
    float plateX = mod(plateIndex, 16.0) * 16.0;

    plate.tlx = texture2D(u_plates, vec2((plateX + 0.5) / 256.0, (plateY + 0.5) / 162.0)).r;
    plate.tly = texture2D(u_plates, vec2((plateX + 1.5) / 256.0, (plateY + 0.5) / 162.0)).r;
    plate.trx = texture2D(u_plates, vec2((plateX + 2.5) / 256.0, (plateY + 0.5) / 162.0)).r;
    plate.bly = texture2D(u_plates, vec2((plateX + 3.5) / 256.0, (plateY + 0.5) / 162.0)).r;

    plate.tl_up = vec3(
                texture2D(u_plates, vec2((plateX + 4.5) / 256.0, (plateY + 0.5) / 162.0)).r,
                texture2D(u_plates, vec2((plateX + 5.5) / 256.0, (plateY + 0.5) / 162.0)).r,
                texture2D(u_plates, vec2((plateX + 6.5) / 256.0, (plateY + 0.5) / 162.0)).r
              );

    plate.tr_up = vec3(
            texture2D(u_plates, vec2((plateX + 7.5) / 256.0, (plateY + 0.5) / 162.0)).r,
            texture2D(u_plates, vec2((plateX + 8.5) / 256.0, (plateY + 0.5) / 162.0)).r,
            texture2D(u_plates, vec2((plateX + 9.5) / 256.0, (plateY + 0.5) / 162.0)).r
          );

    plate.br_up = vec3(
            texture2D(u_plates, vec2((plateX + 10.5) / 256.0, (plateY + 0.5) / 162.0)).r,
            texture2D(u_plates, vec2((plateX + 11.5) / 256.0, (plateY + 0.5) / 162.0)).r,
            texture2D(u_plates, vec2((plateX + 12.5) / 256.0, (plateY + 0.5) / 162.0)).r
          );

    plate.bl_up = vec3(
            texture2D(u_plates, vec2((plateX + 13.5) / 256.0, (plateY + 0.5) / 162.0)).r,
            texture2D(u_plates, vec2((plateX + 14.5) / 256.0, (plateY + 0.5) / 162.0)).r,
            texture2D(u_plates, vec2((plateX + 15.5) / 256.0, (plateY + 0.5) / 162.0)).r
          );


    return plate;
}


vec3 ecefVector(vec3 pos) {
    PlateData plate = getPosPlate(pos);

    vec2 uv = vec2((pos.x - plate.trx) / (plate.tlx - plate.trx), (pos.y - plate.tly) / (plate.bly - plate.tly));

    vec3 up = normalize(mix(mix(plate.tr_up, plate.tl_up, uv.xxx), mix(plate.bl_up, plate.br_up, uv.xxx), uv.yyy));

    return up * u_plate_up_scale * (1.0 + (pos.z * u_scale_factor));
}



void main(void){


    vec3 pos = vec3(instanceMatrix * vec4(position, 1.0));
    
    
    vec4 p;

    if (u_zoom_transition == 1.0) {
        vec3 alteredPos = vec3(
          pos.x + ((pos.x < 0.5 && u_crossed_dateline && u_near_dateline) 
                   ? 1.0
                : (pos.x > 0.5 && !u_crossed_dateline && u_near_dateline) 
                   ? -1.0
                : 0.0), 
          
          pos.y, 
          pos.z
        );

        p = projectionMatrix * vec4(alteredPos, 1.0);

    } else {
        p = projectionMatrix * u_matrix_globe_merc * vec4(ecefVector(pos), 1.0);

        if (u_zoom_transition >= 0.0) {
            vec3 alteredPos = vec3(
              pos.x + ((pos.x < 0.5 && u_crossed_dateline && u_near_dateline) 
                       ? 1.0 
                    : (pos.x > 0.5 && !u_crossed_dateline && u_near_dateline) 
                       ? -1.0 
                    : 0.0), 
              pos.y, 
              pos.z
            );


            vec4 merc = vec4(alteredPos, 1.0);

            merc.xy = (merc.xy - u_centerInMerc) * u_pixelsPerMeterRatio + u_centerInMerc;
            merc.z *= u_pixelsPerMeterRatio;
            merc = projectionMatrix * merc;

            p = mix(p, merc, u_zoom_transition);

        }

    }

    gl_Position = p;

    vColor = instanceColor;

}
`;

export const threeGeomInstanceFragShader = `
varying vec3 vColor;
uniform sampler2D u_plates;
    
#define INDEX 1


void main() {
    // float indexOffset = float(INDEX) * 3.0; 
    // Sample the texture
    
    
    // float red = texture2D(u_plates, vec2(ACROSS_VALUE / 256.0, ROW_VALUE / 162.0)).r;
    
    // Take the index 
    // divide by 16 and floor it, add 0.5, this will be the ROW_VALUE
    // get the remainder after dividing it, so 30/16 = remainder 14, then * 16, 224, add 0.5 is the ACROSS_VALUE + offset

    // float red = texture2D(u_plates, vec2(0.5 / 256.0, 0.5 / 162.0)).r;
    
 
    gl_FragColor = vec4(0.0, 0.0, 0.0, 1.0);
    // Use the fetched values as the final color
    // gl_FragColor = vec4(color.rgb, 1.0);
}
`;
